import React from "react";
import { FormProvider, useForm } from "react-hook-form";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { BusinessReport, VariablesDict } from "@/modules/snapshots/businessReports.types";
import { InjectVariablesModalRow } from "./row";

interface InjectVariablesModalProps {
  businessReport: BusinessReport;
  generateReport: (variables: VariablesDict) => void;
  onVariablesModalClose: () => void;
}

export interface InjectVariablesModalFormInputs {
  [key: string]: string;
}

export const InjectVariablesModal: React.FC<InjectVariablesModalProps> = ({
  onVariablesModalClose,
  businessReport,
  generateReport,
}) => {
  const [isOpen, setIsOpen] = React.useState(true);
  const handleClose = () => {
    setIsOpen(false);
  };

  const methods = useForm<InjectVariablesModalFormInputs>();

  const onSubmit = async (payload: InjectVariablesModalFormInputs) => {
    generateReport(payload);
    handleClose();
  };

  return (
    <Dialog open={isOpen} onOpenChange={onVariablesModalClose}>
      <DialogContent className="max-w-[60vw]">
        <FormProvider {...methods}>
          <form onSubmit={methods.handleSubmit(onSubmit)}>
            <DialogHeader>
              <DialogTitle>Please inject variables</DialogTitle>
            </DialogHeader>
            <div className="flex flex-grow flex-col space-y-4 overflow-hidden">
              <p className="text-md my-2 text-gray-500">Please inject variables to the SnapShot</p>
              <div className="max-h-[320px] overflow-y-auto">
                {businessReport.variables.map(variable => (
                  <InjectVariablesModalRow key={variable} variable={variable} businessReport={businessReport} />
                ))}
              </div>
            </div>
            <div className="mt-4 flex justify-between">
              <Button variant="outline" onClick={handleClose}>
                Cancel
              </Button>

              <Button type="submit">Generate</Button>
            </div>
          </form>
        </FormProvider>
      </DialogContent>
    </Dialog>
  );
};
